import { InfoIcon as PhosphorInfoIcon } from "@phosphor-icons/react/dist/ssr/Info";

import { createAppIcon } from "@/components/createAppIcon";

export const InfoIcon = /* @__PURE__ */ createAppIcon(PhosphorInfoIcon);
